import { useDebugValue, useEffect, useState } from 'react';

import ajaxClient from '../../../../utils/ajaxClient';
import { isUserLoggedIn } from '../../../../helpers/userMetadataHelper';
import bindDictionaryItemsToReactJsonSchemaForm from '../helpers/bindDictionaryItemsToReactJsonSchemaForm';
import { interceptErrorMessage } from '../../../../shared/helpers/apiErrorsInterceptor';

const useGetQuestionnaire = (id, onSuccess, onError) => {
  useDebugValue('useGetQuestionnaire');

  const [isQuestionnaireFetching, setIsFetching] = useState(true);
  const [questionnaire, setQuestionnaire] = useState({});
  const [schema, setSchema] = useState(null);
  const [uiSchema, setUiSchema] = useState(null);

  const urlResolver = () => {
    if (isUserLoggedIn()) {
      return `Forms/${id}`;
    }

    return `questionnaires/${id}`;
  };

  const processResponseData = (data) => {
    const { schemaObject, uiSchemaObject } = bindDictionaryItemsToReactJsonSchemaForm(data.definition, data.sources);
    setQuestionnaire(data);
    setSchema(schemaObject);
    setUiSchema(uiSchemaObject);
    onSuccess(data.fields || [], schemaObject);
  };

  const fetchQuestionnaires = () => {
    const url = urlResolver();
    setIsFetching(true);
    return ajaxClient
      .getRequest(url, null)
      .then((response) => {
        if (response) {
          if (response.data) {
            processResponseData(response.data);
          }
          setIsFetching(false);
        }
      }).catch((exception) => {
        if (onError) {
          onError(interceptErrorMessage(exception));
          setIsFetching(false);
        }
      });
  };

  useEffect(() => {
    if (id) {
      fetchQuestionnaires(id);
    }
  }, [id]);

  return {
    isQuestionnaireFetching,
    questionnaireTitle: questionnaire.name,
    schema,
    uiSchema,
  };
};

export default useGetQuestionnaire;
